module.exports = __webpack_public_path__ + "img/news_banner.23b353d6.jpg";